import React from "react";

const Footer = () => (
  <footer className="border-t border-line bg-panel">
    <div className="mx-auto max-w-content px-5 py-16 sm:px-8">
      <div className="flex flex-col gap-10 sm:flex-row sm:items-start sm:justify-between">
        <div className="max-w-md">
          <p className="text-3xl font-bold leading-tight text-ink">
            Let's talk about what AI-augmented delivery could do for your team.
          </p>
          <p className="mt-4 text-ink-soft">
            Available for CTO and fractional CTO engagements. Active SC clearance.
          </p>
        </div>
        <div className="flex flex-col gap-2 text-ink-soft sm:items-end sm:text-right">
          <a href="mailto:steady@steadtec.com" className="text-ink underline decoration-line underline-offset-4 hover:text-accent hover:decoration-accent">
            steady@steadtec.com
          </a>
          <a href="tel:07455174786" className="hover:text-ink">07455 174786</a>
          <a href="/cv" className="hover:text-ink">Read the full CV</a>
          <a href="/book" className="hover:text-ink">Sledgehammers and Shit Umbrellas, Jan 2027</a>
        </div>
      </div>
      <p className="mt-16 text-sm text-ink-faint">
        © {new Date().getFullYear()} Simon Stead.
      </p>
    </div>
  </footer>
);

export default Footer;
